import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const StaffRoster = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [staffList, setStaffList] = useState([]); // List of all active staff
  const [searchedStaff, setSearchedStaff] = useState([]); // Search results
  const [showDropdown, setShowDropdown] = useState(false);
  
  // The table of assigned shifts
  const [rosterList, setRosterList] = useState([]);

  const initialFormState = {
    staff_cd: "",
    staff_name: "",
    role: "",
    department: "",
    
    // Temporary inputs for adding to the list
    current_date: "",
    current_shift: ""
  };

  const [formData, setFormData] = useState(initialFormState);

  // --- INITIAL DATA LOAD (Fetch all Active Staff) ---
  useEffect(() => {
    const fetchAllStaff = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/staff?employee_id=${user?.id}`);
        const data = await res.json();
        setStaffList(data); // We will use this to populate the main dropdown
      } catch (err) {
        console.error("Failed to load staff", err);
      }
    };
    fetchAllStaff();
  }, []);

  // --- 1. SEARCH LOGIC (For Edit/View Modes) ---
  const searchRoster = async (text) => {
    setSearchText(text);
    if (text.length < 2) {
      setSearchedStaff([]);
      setShowDropdown(false);
      return;
    }
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster/search?q=${text}&employee_id=${user?.id}`);
      const data = await res.json();
      setSearchedStaff(data);
      setShowDropdown(true);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  // Select a staff member to view/edit their existing roster
  const selectStaffToEdit = async (staff) => {
    setFormData(prev => ({
      ...prev,
      staff_cd: staff.staff_cd,
      staff_name: staff.staff_name,
      role: staff.role,
      department: staff.department
    }));
    setSearchText(`${staff.staff_name} | ${staff.staff_cd}`);
    setShowDropdown(false);

    // Fetch their existing future shifts
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster/${staff.staff_cd}?employee_id=${user?.id}`);
      const existingRoster = await res.json();
      setRosterList(existingRoster);
    } catch (err) {
      console.error("Error fetching existing roster");
    }

    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };

  // Select a staff member when creating a NEW roster
  const handleStaffSelect = (e) => {
    const selectedCd = e.target.value;
    const staffObj = staffList.find(s => s.staff_cd === selectedCd);
    
    if (staffObj) {
      setFormData(prev => ({
        ...prev,
        staff_cd: staffObj.staff_cd,
        staff_name: staffObj.staff_name,
        role: staffObj.role,
        department: staffObj.department
      }));
      setRosterList([]); // Clear table for new staff
    } else {
      setFormData(initialFormState);
      setRosterList([]);
    }
  };

  // --- 2. LIST MANAGEMENT ---
  const addShiftToList = () => {
    if (!formData.staff_cd) return alert("Please select a Staff Member first.");
    if (!formData.current_date || !formData.current_shift) return alert("Please select both Date and Shift.");

    // Prevent duplicate dates in the UI
    if (rosterList.some(r => r.roster_date === formData.current_date)) {
      return alert("A shift is already assigned for this date.");
    }

    const newShift = {
      roster_date: formData.current_date,
      shift_type: formData.current_shift,
      isNew: true // Flag to know it hasn't been saved to DB yet
    };

    // Keep the list sorted by date automatically
    const updatedList = [...rosterList, newShift].sort((a, b) => new Date(a.roster_date) - new Date(b.roster_date));
    setRosterList(updatedList);

    // Clear temp inputs
    setFormData(prev => ({ ...prev, current_date: "", current_shift: "" }));
  };

  const removeShift = async (indexToRemove, shiftData) => {
    // If it's already in the database, delete it from the DB
    if (shiftData.roster_id) {
      const confirmDelete = window.confirm("Remove this shift from the database?");
      if (!confirmDelete) return;

      try {
        await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster/${shiftData.roster_id}`, { method: 'DELETE' });
      } catch (err) {
        console.error("Error deleting from DB");
      }
    }
    
    // Remove from UI state
    setRosterList(rosterList.filter((_, i) => i !== indexToRemove));
  };


  // --- 3. FORM ACTIONS ---
  const clearForm = () => {
    setFormData(initialFormState);
    setRosterList([]);
    setSearchText("");
    setIsDisabled(false);
  };

  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") handleSubmit();
  }, [triggerSave]);

  useEffect(() => {
    if (screenAction === "add") clearForm();
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
    if (screenAction === "refresh") clearForm();
    if (screenAction === "print") printForm()
  }, [screenAction]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // --- 4. SAVE LOGIC ---
//   const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!formData.staff_cd) return alert("Staff Selection is required!");
//     if (rosterList.length === 0) return alert("Please add at least one shift to the roster.");

//     // Filter out shifts that are already saved to avoid redundant API calls
//     const newShiftsToSave = rosterList.filter(r => r.isNew);

//     if (newShiftsToSave.length === 0) {
//       return alert("No new shifts to save.");
//     }

//     const payload = {
//       staff_cd: formData.staff_cd,
//       created_by: user?.id,
//       roster: newShiftsToSave
//     };

//     try {
//       const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
      
//       if (res.ok) {
//         alert("Roster Saved Successfully!");
//         clearForm();
//       } else {
//         alert("Error saving roster");
//       }
//     } catch (err) {
//       alert("Network error while saving.");
//     }
//   };

// --- 4. SAVE LOGIC (Handles POST and PUT) ---
  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    
    if (!formData.staff_cd) return alert("Staff Selection is required!");
    if (rosterList.length === 0) return alert("Please add at least one shift to the roster.");

    // Check if we have any existing records (meaning this is an update)
    // Or if the screen action was explicitly set to 'edit'
    const isExisting = rosterList.some(r => !r.isNew) || screenAction === "edit";

    // Determine Method and URL based on your existing pattern
    const method = isExisting ? "PUT" : "POST";
    const url = method === "POST" 
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster" 
      : `https://hmsapi.emedhatechnologies.com/master/api/api/staff-roster/${formData.staff_cd}`;

    // Filter shifts: 
    // If it's a POST (new), save only new shifts.
    // If it's a PUT (update), send all shifts because the backend uses ON DUPLICATE KEY UPDATE 
    // which will update existing ones and insert new ones.
    const shiftsToSave = isExisting ? rosterList : rosterList.filter(r => r.isNew);

    if (shiftsToSave.length === 0) {
      return alert("No new shifts to save.");
    }

    // Build payload matching backend expectations
    const payload = {
      staff_cd: formData.staff_cd,
      // Your backend uses 'updated_by' for PUT and 'created_by' for POST, so we send both to be safe
      created_by: user?.id,
      updated_by: user?.id, 
      roster: shiftsToSave
    };

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      const data = await res.json();

      if (res.ok && data.success !== false) {
        alert(`Roster ${method === "POST" ? "Saved" : "Updated"} Successfully!`);
        clearForm();
      } else {
        alert("Error: " + (data.message || "Failed to save roster"));
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Network error while saving.");
    }
  };

  // --- 5. PRINT FORM ---
  const printForm = () => {
    if (!formData.staff_cd || rosterList.length === 0) {
      return alert("No roster data to print. Please select a staff member and add shifts.");
    }

    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString();

    const htmlContent = `
      <html>
        <head>
          <title>Staff Roster - ${formData.staff_name}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            
            /* Header Section */
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #282f81; padding-bottom: 10px; margin-bottom: 20px; }
            .hospital-info h1 { margin: 0; color: #282f81; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #11abea; font-size: 18px; }
            
            /* Section Styling */
            .section-header { background: #f2f4f4; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #282f81; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
            
            /* Data Grid for Staff Info */
            .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
            .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
            .label { font-weight: 600; width: 150px; color: #555; }
            .value { flex: 1; color: #000; }
            
            /* Table for Roster */
            table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 13px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            th { background-color: #f2f4f4; color: #282f81; }
            .off-shift { color: red; font-weight: bold; }

            /* Footer */
            .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
            .sig-box { margin-top: 40px; display: flex; justify-content: space-between; }
            .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

            @media print {
              button { display: none; }
              body { padding: 20px; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="hospital-info">
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p>123 Medical Park, Health City - 560001</p>
              <p>Phone: +91 98765 43210 | Email: hr@citycare.com</p>
            </div>
            <div class="report-title">
              <h2>STAFF ROSTER SCHEDULE</h2>
              <p>Printed On: ${today}</p>
            </div>
          </div>

          <div class="section-header">Staff Details</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Staff ID:</span> <span class="value">${formData.staff_cd}</span></div>
            <div class="data-item"><span class="label">Name:</span> <span class="value">${formData.staff_name}</span></div>
            <div class="data-item"><span class="label">Role:</span> <span class="value">${formData.role}</span></div>
            <div class="data-item"><span class="label">Department:</span> <span class="value">${formData.department}</span></div>
          </div>

          <div class="section-header">Assigned Shifts</div>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Day</th>
                <th>Shift Type</th>
              </tr>
            </thead>
            <tbody>
              ${rosterList.map(row => {
                const dayName = new Date(row.roster_date).toLocaleDateString('en-US', { weekday: 'long' });
                const isOff = row.shift_type === "Weekly Off";
                return `
                  <tr>
                    <td><strong>${row.roster_date}</strong></td>
                    <td>${dayName}</td>
                    <td class="${isOff ? 'off-shift' : ''}">${row.shift_type}</td>
                  </tr>
                `;
              }).join('')}
            </tbody>
          </table>

          <div class="sig-box">
            <div class="sig">Staff Signature</div>
            <div class="sig">HR / Department Head</div>
          </div>

          <div class="footer">
            This is a computer-generated schedule and is subject to change based on hospital requirements.
          </div>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
    
    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

  return (
    <div className="registration-container fade-in">
      
      {/* SEARCH BAR (For Edit/View Modes) */}
      {(screenAction === "edit" || screenAction === "view") && (
        <div className="patient-search">
          <label>Search Existing Roster</label>
          <input
            type="text"
            value={searchText}
            placeholder="Search Staff by ID or Name..."
            onChange={(e) => searchRoster(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (searchedStaff.length === 1) selectStaffToEdit(searchedStaff[0]);
              }
            }}
            autoFocus
          />
          {showDropdown && searchedStaff.length > 0 && (
            <div className="patient-dropdown">
              {searchedStaff.map((staff) => (
                <div key={staff.staff_cd} className="patient-item" onClick={() => selectStaffToEdit(staff)}>
                  {staff.staff_name} | {staff.department} | {staff.staff_cd}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="luxury-form">
        
        {/* IDENTIFICATION */}
        <div className="form-section-header">
          <h3>Staff Selection</h3>
        </div>
        <div className="form-grid">
          
          <div className="input-box">
            <label>Select Staff Member <span style={{color:'red'}}>*</span></label>
            <select 
              name="staff_cd" 
              value={formData.staff_cd} 
              onChange={handleStaffSelect} 
              disabled={isDisabled || screenAction === "edit" || screenAction === "view"}
            >
              <option value="">-- Choose Staff --</option>
              {staffList.map(staff => (
                <option key={staff.staff_cd} value={staff.staff_cd}>
                  {staff.staff_name} ({staff.role})
                </option>
              ))}
            </select>
          </div>

          <div className="input-box read-only">
            <label>Staff ID</label>
            <input type="text" value={formData.staff_cd} readOnly placeholder="Auto-fills" />
          </div>
          <div className="input-box read-only">
            <label>Role</label>
            <input type="text" value={formData.role} readOnly placeholder="Auto-fills" />
          </div>
          <div className="input-box read-only">
            <label>Department</label>
            <input type="text" value={formData.department} readOnly placeholder="Auto-fills" />
          </div>
        </div>

        {/* ROSTER SCHEDULING CONTROLS */}
        <div className="form-section-header" style={{ marginTop: '20px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
          <h3>Assign Shift</h3>
        </div>
        <div className="form-grid" style={{ alignItems: 'flex-end', backgroundColor: '#a0dbf3', padding: '15px', borderRadius: '8px' }}>
          
          <div className="input-box">
            <label>Date</label>
            <input 
              type="date" 
              name="current_date" 
              value={formData.current_date} 
              onChange={handleChange} 
              disabled={isDisabled || !formData.staff_cd} 
              min={new Date().toISOString().split("T")[0]} // Prevent past dates
            />
          </div>

          <div className="input-box">
            <label>Shift Type</label>
            <select name="current_shift" value={formData.current_shift} onChange={handleChange} disabled={isDisabled || !formData.staff_cd}>
              <option value="">Select Shift</option>
              <option value="Morning">Morning (8 AM - 4 PM)</option>
              <option value="Evening">Evening (4 PM - 12 AM)</option>
              <option value="Night">Night (12 AM - 8 AM)</option>
              <option value="General">General (10 AM - 6 PM)</option>
              <option value="Weekly Off">Weekly Off (Leave)</option>
            </select>
          </div>
          
          <button 
             type="button" 
             onClick={addShiftToList} 
             disabled={isDisabled || !formData.current_date || !formData.current_shift}
             style={{ padding: '10px 20px', height: '40px', backgroundColor: '#282f81', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
             + Add to Roster
          </button>
        </div>

        {/* SELECTED SHIFTS TABLE */}
        {rosterList.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead style={{ backgroundColor: '#e9ecef', borderBottom: '2px solid #ccc' }}>
                <tr>
                  <th style={{ padding: '10px' }}>Date</th>
                  <th style={{ padding: '10px' }}>Day of Week</th>
                  <th style={{ padding: '10px' }}>Shift Assigned</th>
                  <th style={{ padding: '10px' }}>Status</th>
                  <th style={{ padding: '10px', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {rosterList.map((row, index) => {
                  const dayName = new Date(row.roster_date).toLocaleDateString('en-US', { weekday: 'long' });
                  const isOff = row.shift_type === "Weekly Off";
                  
                  return (
                    <tr key={index} style={{ borderBottom: '1px solid #ddd', backgroundColor: isOff ? '#fbeeee' : 'transparent' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>{row.roster_date}</td>
                      <td style={{ padding: '10px' }}>{dayName}</td>
                      <td style={{ padding: '10px', color: isOff ? 'red' : 'inherit' }}>{row.shift_type}</td>
                      <td style={{ padding: '10px' }}>
                        {row.isNew 
                          ? <span style={{ color: 'orange', fontSize: '12px' }}>Pending Save</span> 
                          : <span style={{ color: 'green', fontSize: '12px' }}>Saved ✓</span>}
                      </td>
                      <td style={{ padding: '10px', textAlign: 'center' }}>
                        {!isDisabled && (
                           <button type="button" onClick={() => removeShift(index, row)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>X</button>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}

      </form>
    </div>
  );
};

export default StaffRoster;